// extracted by mini-css-extract-plugin
export var formContainer = "_gr-0";
export var message = "_gr-1";